export const userColors = [
  "#958DF1",
  "#F98181",
  "#FBBC88",
  "#FAF594",
  "#70CFF8",
  "#94FADB",
  "#B9F18D",
];

export function randomElement(array: Array<any>) {
  return array[Math.floor(Math.random() * array.length)];
}
